import React from 'react';

const Notifications = () => {
  return <h2>Notifications Management Page</h2>;
};

export default Notifications;